// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  IAuditLogInfoDto,
  IEntityAttributesInfoDto,
  IErrorDto,
  IPageAuditLogChangesetInfoDto,
  IPageable,
} from '../models/index';
import {
    IAuditLogInfoDtoFromJSON,
    IAuditLogInfoDtoToJSON,
    IEntityAttributesInfoDtoFromJSON,
    IEntityAttributesInfoDtoToJSON,
    IErrorDtoFromJSON,
    IErrorDtoToJSON,
    IPageAuditLogChangesetInfoDtoFromJSON,
    IPageAuditLogChangesetInfoDtoToJSON,
    IPageableFromJSON,
    IPageableToJSON,
} from '../models/index';

export interface GetAuditChangesetChangesRequest {
    changesetId: number;
}

export interface GetAuditChangesetChangesByIdsRequest {
    ids: Array<number>;
}

export interface GetEntityAttributesRequest {
    employeeId?: number;
    organizationId?: number;
    claimId?: number;
    lockboxId?: number;
    planId?: number;
    domainTypes?: Set<GetEntityAttributesDomainTypesEnum>;
}

export interface SearchAuditChangesetRequest {
    pageable: IPageable;
    employeeId?: number;
    organizationId?: number;
    claimId?: number;
    lockboxId?: number;
    planId?: number;
    entityId?: number;
    searchTerm?: string;
    fieldNames?: Array<string>;
    actionTypes?: Array<SearchAuditChangesetActionTypesEnum>;
    domainTypes?: Array<SearchAuditChangesetDomainTypesEnum>;
    dateFrom?: Date;
    dateTo?: Date;
}

/**
 * AuditServiceServiceApi - interface
 * 
 * @export
 * @interface AuditServiceServiceApiInterface
 */
export interface AuditServiceServiceApiInterface {
    /**
     * 
     * @param {number} changesetId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuditServiceServiceApiInterface
     */
    getAuditChangesetChangesRaw(requestParameters: GetAuditChangesetChangesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<IAuditLogInfoDto>>>;

    /**
     */
    getAuditChangesetChanges(requestParameters: GetAuditChangesetChangesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<IAuditLogInfoDto>>;

    /**
     * 
     * @param {Array<number>} ids 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuditServiceServiceApiInterface
     */
    getAuditChangesetChangesByIdsRaw(requestParameters: GetAuditChangesetChangesByIdsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<string>>;

    /**
     */
    getAuditChangesetChangesByIds(requestParameters: GetAuditChangesetChangesByIdsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<string>;

    /**
     * 
     * @param {number} [employeeId] 
     * @param {number} [organizationId] 
     * @param {number} [claimId] 
     * @param {number} [lockboxId] 
     * @param {number} [planId] 
     * @param {Set<'ENROLLMENT' | 'EMPLOYEE' | 'CLAIM' | 'ORGANIZATION' | 'PLAN' | 'PLAN_YEAR' | 'PLAN_CONFIGS' | 'EXPRESS_SETUP' | 'LOCKBOX' | 'DEDUCTIBLES' | 'ACCOUNT' | 'HEALTH_PLAN' | 'PLAN_TERM_PROPERTIES' | 'CHECK' | 'ROLE' | 'CARD' | 'LETTER_OF_MEDICAL_NECESSITY' | 'SERVICE' | 'COPAY' | 'PAYMENT_METHOD' | 'INVESTMENTS' | 'CIP' | 'PAYOUT_DEFINITION' | 'CARD_PURSE' | 'CONTRIBUTION'>} [domainTypes] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuditServiceServiceApiInterface
     */
    getEntityAttributesRaw(requestParameters: GetEntityAttributesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<IEntityAttributesInfoDto>>>;

    /**
     */
    getEntityAttributes(requestParameters: GetEntityAttributesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<IEntityAttributesInfoDto>>;

    /**
     * 
     * @param {IPageable} pageable 
     * @param {number} [employeeId] 
     * @param {number} [organizationId] 
     * @param {number} [claimId] 
     * @param {number} [lockboxId] 
     * @param {number} [planId] 
     * @param {number} [entityId] 
     * @param {string} [searchTerm] 
     * @param {Array<string>} [fieldNames] 
     * @param {Array<'CREATE' | 'UPDATE' | 'DELETE' | 'UPDATE_FROM_HIERARCHY'>} [actionTypes] 
     * @param {Array<'ENROLLMENT' | 'EMPLOYEE' | 'CLAIM' | 'ORGANIZATION' | 'PLAN' | 'PLAN_YEAR' | 'PLAN_CONFIGS' | 'EXPRESS_SETUP' | 'LOCKBOX' | 'DEDUCTIBLES' | 'ACCOUNT' | 'HEALTH_PLAN' | 'PLAN_TERM_PROPERTIES' | 'CHECK' | 'ROLE' | 'CARD' | 'LETTER_OF_MEDICAL_NECESSITY' | 'SERVICE' | 'COPAY' | 'PAYMENT_METHOD' | 'INVESTMENTS' | 'CIP' | 'PAYOUT_DEFINITION' | 'CARD_PURSE' | 'CONTRIBUTION'>} [domainTypes] 
     * @param {Date} [dateFrom] 
     * @param {Date} [dateTo] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuditServiceServiceApiInterface
     */
    searchAuditChangesetRaw(requestParameters: SearchAuditChangesetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<IPageAuditLogChangesetInfoDto>>;

    /**
     */
    searchAuditChangeset(requestParameters: SearchAuditChangesetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<IPageAuditLogChangesetInfoDto>;

}

/**
 * 
 */
export class AuditServiceServiceApi extends runtime.BaseAPI implements AuditServiceServiceApiInterface {

    /**
     */
    async getAuditChangesetChangesRaw(requestParameters: GetAuditChangesetChangesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<IAuditLogInfoDto>>> {
        if (requestParameters['changesetId'] == null) {
            throw new runtime.RequiredError(
                'changesetId',
                'Required parameter "changesetId" was null or undefined when calling getAuditChangesetChanges().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/activity-logs/{changeset-id}`;
        urlPath = urlPath.replace(`{${"changeset-id"}}`, encodeURIComponent(String(requestParameters['changesetId'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(IAuditLogInfoDtoFromJSON));
    }

    /**
     */
    async getAuditChangesetChanges(requestParameters: GetAuditChangesetChangesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<IAuditLogInfoDto>> {
        const response = await this.getAuditChangesetChangesRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async getAuditChangesetChangesByIdsRaw(requestParameters: GetAuditChangesetChangesByIdsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<string>> {
        if (requestParameters['ids'] == null) {
            throw new runtime.RequiredError(
                'ids',
                'Required parameter "ids" was null or undefined when calling getAuditChangesetChangesByIds().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['ids'] != null) {
            queryParameters['ids'] = requestParameters['ids'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/activity-logs-map`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        if (this.isJsonMime(response.headers.get('content-type'))) {
            return new runtime.JSONApiResponse<string>(response);
        } else {
            return new runtime.TextApiResponse(response) as any;
        }
    }

    /**
     */
    async getAuditChangesetChangesByIds(requestParameters: GetAuditChangesetChangesByIdsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<string> {
        const response = await this.getAuditChangesetChangesByIdsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async getEntityAttributesRaw(requestParameters: GetEntityAttributesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<IEntityAttributesInfoDto>>> {
        const queryParameters: any = {};

        if (requestParameters['employeeId'] != null) {
            queryParameters['employee_id'] = requestParameters['employeeId'];
        }

        if (requestParameters['organizationId'] != null) {
            queryParameters['organization_id'] = requestParameters['organizationId'];
        }

        if (requestParameters['claimId'] != null) {
            queryParameters['claim_id'] = requestParameters['claimId'];
        }

        if (requestParameters['lockboxId'] != null) {
            queryParameters['lockbox_id'] = requestParameters['lockboxId'];
        }

        if (requestParameters['planId'] != null) {
            queryParameters['plan_id'] = requestParameters['planId'];
        }

        if (requestParameters['domainTypes'] != null) {
            queryParameters['domain_types'] = requestParameters['domainTypes'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/attributes-list`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(IEntityAttributesInfoDtoFromJSON));
    }

    /**
     */
    async getEntityAttributes(requestParameters: GetEntityAttributesRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<IEntityAttributesInfoDto>> {
        const response = await this.getEntityAttributesRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async searchAuditChangesetRaw(requestParameters: SearchAuditChangesetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<IPageAuditLogChangesetInfoDto>> {
        if (requestParameters['pageable'] == null) {
            throw new runtime.RequiredError(
                'pageable',
                'Required parameter "pageable" was null or undefined when calling searchAuditChangeset().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['employeeId'] != null) {
            queryParameters['employee_id'] = requestParameters['employeeId'];
        }

        if (requestParameters['organizationId'] != null) {
            queryParameters['organization_id'] = requestParameters['organizationId'];
        }

        if (requestParameters['claimId'] != null) {
            queryParameters['claim_id'] = requestParameters['claimId'];
        }

        if (requestParameters['lockboxId'] != null) {
            queryParameters['lockbox_id'] = requestParameters['lockboxId'];
        }

        if (requestParameters['planId'] != null) {
            queryParameters['plan_id'] = requestParameters['planId'];
        }

        if (requestParameters['entityId'] != null) {
            queryParameters['entity_id'] = requestParameters['entityId'];
        }

        if (requestParameters['searchTerm'] != null) {
            queryParameters['search_term'] = requestParameters['searchTerm'];
        }

        if (requestParameters['fieldNames'] != null) {
            queryParameters['field_names'] = requestParameters['fieldNames'];
        }

        if (requestParameters['actionTypes'] != null) {
            queryParameters['action_types'] = requestParameters['actionTypes'];
        }

        if (requestParameters['domainTypes'] != null) {
            queryParameters['domain_types'] = requestParameters['domainTypes'];
        }

        if (requestParameters['dateFrom'] != null) {
            queryParameters['date_from'] = (requestParameters['dateFrom'] as any).toISOString().substring(0,10);
        }

        if (requestParameters['dateTo'] != null) {
            queryParameters['date_to'] = (requestParameters['dateTo'] as any).toISOString().substring(0,10);
        }

        if (requestParameters['pageable'] != null) {
            queryParameters['pageable'] = requestParameters['pageable'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/activity-logs`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => IPageAuditLogChangesetInfoDtoFromJSON(jsonValue));
    }

    /**
     */
    async searchAuditChangeset(requestParameters: SearchAuditChangesetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<IPageAuditLogChangesetInfoDto> {
        const response = await this.searchAuditChangesetRaw(requestParameters, initOverrides);
        return await response.value();
    }

}

/**
  * @export
  * @enum {string}
  */
export enum GetEntityAttributesDomainTypesEnum {
    ENROLLMENT = 'ENROLLMENT',
    EMPLOYEE = 'EMPLOYEE',
    CLAIM = 'CLAIM',
    ORGANIZATION = 'ORGANIZATION',
    PLAN = 'PLAN',
    PLAN_YEAR = 'PLAN_YEAR',
    PLAN_CONFIGS = 'PLAN_CONFIGS',
    EXPRESS_SETUP = 'EXPRESS_SETUP',
    LOCKBOX = 'LOCKBOX',
    DEDUCTIBLES = 'DEDUCTIBLES',
    ACCOUNT = 'ACCOUNT',
    HEALTH_PLAN = 'HEALTH_PLAN',
    PLAN_TERM_PROPERTIES = 'PLAN_TERM_PROPERTIES',
    CHECK = 'CHECK',
    ROLE = 'ROLE',
    CARD = 'CARD',
    LETTER_OF_MEDICAL_NECESSITY = 'LETTER_OF_MEDICAL_NECESSITY',
    SERVICE = 'SERVICE',
    COPAY = 'COPAY',
    PAYMENT_METHOD = 'PAYMENT_METHOD',
    INVESTMENTS = 'INVESTMENTS',
    CIP = 'CIP',
    PAYOUT_DEFINITION = 'PAYOUT_DEFINITION',
    CARD_PURSE = 'CARD_PURSE',
    CONTRIBUTION = 'CONTRIBUTION'
}
/**
  * @export
  * @enum {string}
  */
export enum SearchAuditChangesetActionTypesEnum {
    CREATE = 'CREATE',
    UPDATE = 'UPDATE',
    DELETE = 'DELETE',
    UPDATE_FROM_HIERARCHY = 'UPDATE_FROM_HIERARCHY'
}
/**
  * @export
  * @enum {string}
  */
export enum SearchAuditChangesetDomainTypesEnum {
    ENROLLMENT = 'ENROLLMENT',
    EMPLOYEE = 'EMPLOYEE',
    CLAIM = 'CLAIM',
    ORGANIZATION = 'ORGANIZATION',
    PLAN = 'PLAN',
    PLAN_YEAR = 'PLAN_YEAR',
    PLAN_CONFIGS = 'PLAN_CONFIGS',
    EXPRESS_SETUP = 'EXPRESS_SETUP',
    LOCKBOX = 'LOCKBOX',
    DEDUCTIBLES = 'DEDUCTIBLES',
    ACCOUNT = 'ACCOUNT',
    HEALTH_PLAN = 'HEALTH_PLAN',
    PLAN_TERM_PROPERTIES = 'PLAN_TERM_PROPERTIES',
    CHECK = 'CHECK',
    ROLE = 'ROLE',
    CARD = 'CARD',
    LETTER_OF_MEDICAL_NECESSITY = 'LETTER_OF_MEDICAL_NECESSITY',
    SERVICE = 'SERVICE',
    COPAY = 'COPAY',
    PAYMENT_METHOD = 'PAYMENT_METHOD',
    INVESTMENTS = 'INVESTMENTS',
    CIP = 'CIP',
    PAYOUT_DEFINITION = 'PAYOUT_DEFINITION',
    CARD_PURSE = 'CARD_PURSE',
    CONTRIBUTION = 'CONTRIBUTION'
}
